export const requestStatus = {
    'loading': 'loading',
    'success': 'success',
    'error': 'error',
    'logout': 'logout',
    'wait_logout': 'wait_logout',
};